import Progress from './progress';

export default Progress;



// WEBPACK FOOTER //
// ./components/progress/index.tsx